import actions from './actions'
import getters from './getters'
import types from './types'

const defaultTextValue = 'Loading...'

const state = {
  visible: false,
  text: null
}

const mutations = {
  [types.SPINNER.SHOW](state, text = defaultTextValue) {
    state.visible = true
    if (typeof text !== 'string') {
      text = defaultTextValue
    }
    state.text = text
  },
  [types.SPINNER.HIDE](state) {
    state.visible = false
    state.text = null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
